import { Fragment } from 'react';
import { Skeleton } from '@mui/material';
import { NavbarSupport } from '@diana/core';
import { usePerformanceReportBuilderPageContext } from '../PerformanceReportBuilderPageContext';

export const HelpButton = () => {
  const { isLoading, error } = usePerformanceReportBuilderPageContext();

  if (isLoading) return <Skeleton variant="circular" width={32} height={32} />;

  if (!error) return <NavbarSupport isFlowBuilder />;

  return <Fragment />;
};
